import { Typography } from "@material-ui/core";
import HeaderGestorConfigs from "../../utils/headerGestorConfigs";
import { useEffect, useState } from "react";
import api from "../../services/api";
import { Alert, AlertTitle, Button, Card, DialogActions, Grid, IconButton, Tooltip } from "@mui/material";
import Loading from "../../load/loading";
import DateHora from "../../utils/dateHora";
import TempoPassado from "../../utils/tempoPassado";
import FichaEstabelecimento from "./fichaEstabelecimento";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { AutorizacaoPDF } from "./exports/autorizacao";
import Paginacao from "../../utils/paginacao";
import { useSearchParams } from "react-router-dom";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default function AutorizacoesExercicioEmitidas({ estabelecimento, geral }) {
    const [autorizacoes, setAutorizacoes] = useState('');
    const [configLista, setConfigLista] = useState('');
    const [searchParams] = useSearchParams();
    const [page, setPage] = useState(searchParams.get("page"));
    const [perPage, setPerPage] = useState(20);

    useEffect(() => {
        setAutorizacoes('')

        api.get(`/autorizacaos?estabelecimentoId=${estabelecimento?._id ?? ''}&page=${page}&perPage=${perPage}`)
            .then(response => {
                // console.log(response)
                setAutorizacoes(response.data.autorizacaos);
                setConfigLista(response.data);
            }).catch(err => { '' })
    }, [estabelecimento?._id, page, perPage]);

    const imprimirPdf = async (dado) => {
        const pdfGerarAquivo = await AutorizacaoPDF(dado);
        pdfGerarAquivo.print();
    };

    return (
        autorizacoes
            ?
            <>
                <Grid style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', justifyContent: 'center' }}>
                    {autorizacoes.map((autorizacao) =>
                        <Card key={autorizacao._id} style={{ padding: 20, marginBottom: 10, width: '49%' }}>
                            <HeaderGestorConfigs
                                menu={true}
                                autorizacao={autorizacao}
                                generatePDF={imprimirPdf}
                                configArea={'autorizacaoExercio'}
                            // title={geral? :''}
                            />

                            <div style={{ padding: 10, position: 'relative' }}>
                                <IconButton size="large" onClick={() => imprimirPdf(autorizacao)} style={{ position: 'absolute', right: 0 }}>
                                    <img src="/img/icones/licenciamentoicon.svg" alt="autor.." width={50} />
                                </IconButton>

                                <Typography>Nº de Autorização: <strong>{autorizacao?.estabelecimento?.numeroAutorizacao}</strong></Typography>
                                <Typography>Data de Emissão: <strong><DateHora date={autorizacao?.dataEmissao} /></strong> </Typography>
                                <Typography>Data de Expiração: <strong><DateHora date={autorizacao?.dataExpiracao} /></strong> </Typography>
                                <Typography>Emitido por: <strong>{autorizacao?.por?.dadosPessoais?.nome}</strong> </Typography>
                                <Typography>Tempo de actividade termina: <strong><TempoPassado date={autorizacao?.dataExpiracao} /></strong> </Typography>
                                <Typography>Director(a) Geral em exercício: <strong>{autorizacao?.directorGeral?.dadosPessoais?.nome}</strong> </Typography>
                            </div>

                            {geral && <FichaEstabelecimento menu={false} estabelecimento={autorizacao?.estabelecimento} />}

                            <DialogActions>
                                <Tooltip title="Clique para abrir">
                                    <Button onClick={() => imprimirPdf(autorizacao)} style={{ background: '#85287e' }} variant="contained">ver</Button>
                                </Tooltip>
                            </DialogActions>
                        </Card>
                    )
                    }
                    {geral &&
                        <Card style={{ marginBottom: 10, width: '99%' }}>
                            <Paginacao
                                configLista={configLista}
                                lista={autorizacoes}
                                page={page}
                                setPage={setPage}
                                setPerPage={setPerPage}
                            // setOrder={setOrder}
                            />
                        </Card>
                    }
                    {autorizacoes.length < 1 &&
                        <Alert severity="warning">
                            <AlertTitle>Para este estabelecimento ainda não foi emitida nenhuma Autorização de Exercício pelo sistema.</AlertTitle>
                        </Alert>
                    }
                </Grid>

            </>
            :
            <Loading />
    )
}